module.exports = __webpack_public_path__ + "img/t.f477fb1c.svg";